(function($, undefined) {
	
	'use strict';
	var popupUtils;
	var smallerFontSizeBtn;
	var biggerFontSizeBtn;
	
	const BASE_FONT_SIZE = 10;
	const MAX_FONT_SIZE = 13;
	const MIN_FONT_SIZE = 8;
	const FONT_SIZE_INTERVAL = 1;
	
	var changeFontSize = function(e) {
		var direction = e.data.direction;
		var htmlStyle = window.getComputedStyle(document.documentElement);
		var currentFontSize = Math.round(htmlStyle.getPropertyValue('font-size').replace('px',''));
		
		var newFontSize = getNewFontSize(currentFontSize, direction);
		document.documentElement.style.fontSize = getFontSizeHtmlPercentage(newFontSize);
		
		biggerFontSizeBtn.prop('disabled', false);
		smallerFontSizeBtn.prop('disabled', false);
		if (newFontSize == MIN_FONT_SIZE || newFontSize - FONT_SIZE_INTERVAL < MIN_FONT_SIZE) {
			smallerFontSizeBtn.prop('disabled', 'disabled');	
		} 
		else if (newFontSize == MAX_FONT_SIZE || newFontSize + FONT_SIZE_INTERVAL > MAX_FONT_SIZE) {
			biggerFontSizeBtn.prop('disabled', 'disabled');
		}
	};
	
	var getNewFontSize = function(fontSize, direction) {
		var newFontSize = fontSize;
		if (direction === "up") {
			if (fontSize + FONT_SIZE_INTERVAL <= MAX_FONT_SIZE) {
				newFontSize = fontSize + FONT_SIZE_INTERVAL;
			}
		} 
		else if (direction === "down") {
			if (fontSize - FONT_SIZE_INTERVAL >= MIN_FONT_SIZE) {
				newFontSize = fontSize - FONT_SIZE_INTERVAL;
			}
		} 
		else {
			console.log('unrecognized direction: ' + direction);
		}
		return newFontSize;
	};
	
	var getFontSizeHtmlPercentage = function(fontSize) {
		return (fontSize / 16 * 100) + '%';
	};
	
	
	var openAudioPopup = function() {
		popupUtils.openPopupById('help-div-audio-popup');
	};
	var openVideoPopup = function() {
		popupUtils.openPopupById('help-div-video-popup');
	};
	
	var init = function () {
		popupUtils = Fw.component.models().popup;
		smallerFontSizeBtn = $('.help-font-size-smaller-btn');
		biggerFontSizeBtn = $('.help-font-size-bigger-btn');
		
		biggerFontSizeBtn.on('click', {direction: "up"}, changeFontSize);
		smallerFontSizeBtn.on('click', {direction: "down"}, changeFontSize); 
		
		$('.help-audio-btn').on('click', openAudioPopup);
		$('.help-video-btn').on('click', openVideoPopup);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
